import { generateUtilityClasses } from "@mui/material";
const toolbarButtonGroupName = "TidalToolbarButtonGroup";
const toolbarButtonGroupClasses = generateUtilityClasses(
  toolbarButtonGroupName,
  ["anchorBottom", "anchorTop", "buttonStack", "divider", "labelsOff", "labelsOn", "root"]
);
export {
  toolbarButtonGroupClasses,
  toolbarButtonGroupName
};
//# sourceMappingURL=classes.js.map
